import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { getValidToken } from "@/lib/auth-token"

/** Gate for the dashboard; remembers where the user was headed. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation()

  if (!getValidToken()) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/?next=${next}`} replace />
  }

  return <>{children}</>
}
